<template>

    <ubi-page-container wide-main-content>
        <ubi-panel style="text-align: center">
            <span >
                {{ $t("exports.description") }}
            </span>
        </ubi-panel>

        <el-dialog
                :title="$t('exports.removeTitle')"
                :visible.sync="modalDelete"
                width="30%"
        >
            <span>{{ $t("exports.removeText") }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalDelete = false">Annuler</el-button>
                <el-button type="danger" @click="handleRemove"> {{ $t("general.selection.remove") }}</el-button>
            </span>
        </el-dialog>

        <ubi-panel class="PortalsList" :full-width="browserContext.up('lg')">

            <template slot="header">
                <template slot="header">
                </template>
            </template>
            <template slot="selection">
                <ubi-list-selection
                        slot="selection"
                        v-model="selected"
                        @select="doSelect"
                        arrow-down
                />
            </template>
            <template slot="actions">
                <el-button
                        icon="export"
                        size="mini"
                        @click="downloadAll"
                        v-if="!selected.length"
                >{{ $t("general.selection.download") }}
                </el-button>
                <span v-else>
                    <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selected.length }}) :</span>
                    <el-button-group class="inline">
                      <el-button class="UsersList-export" size="mini" @click="handleDownloadSelected">{{$t("general.selection.download")}}</el-button>
                      <el-button class="UsersList-export" size="mini" @click="openDeleteModal(null)">{{$t("general.selection.remove")}}</el-button>
                    </el-button-group>
                </span>

            </template>

            <el-table
                    ref="tableExports"
                    :data="getExports.list"
                    v-loading="loading"
                    :element-loading-text="$t('portals.list.chargementDonnees')"
                    v-if="browserContext.up('lg')"
                    @select="selectedChanged"
                    @select-all="selectAllChanged"
            >

                <el-table-column type="selection" width="68"/>

                <el-table-column  min-width="80">
                    <template v-slot="{ row: result }">
                        <img
                                alt=""
                                width="50"
                                :src="require('@/assets/'+ result.extension +'-icon.png')"
                        />
                    </template>
                </el-table-column>

                <el-table-column :label="$t('general.sort.dateCreation')" min-width="100">
                    <template v-slot="{ row: result }">
                        {{ formatDateFromTimestamp(result.dtCreate)}}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('general.sort.title')" min-width="150">
                    <template v-slot="{ row: result }">
                        {{result.relativePathname}}
                    </template>
                </el-table-column>

                <el-table-column
                        :min-width="110"
                        fixed="right"
                        label="Opérations"
                >
                    <template slot-scope="scope">
                        <button @click="handleDownload(scope.row)" class="btn btn-primary"
                                type="button"
                        >
                            <em class="el-icon-download"></em>
                        </button>
                        <button style="margin-left: 10px" @click="openDeleteModal(scope.row)" class="btn btn-danger"
                                type="button"
                        >
                            <em class="el-icon-delete"></em>
                        </button>

                    </template>
                </el-table-column>

            </el-table>

        </ubi-panel>
    </ubi-page-container>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import UbiListSelection from '../components/lists/ListSelection'
import { getExports, downloadExports, removeExports } from '@/services/exports'
import moment from 'moment'
import _uniq from 'lodash/uniq'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'Exports',
  inject: ['browserContext'],
  components: {
    UbiPanel,
    UbiPageContainer,
    UbiListSelection
  },
  data () {
    return {
      loading: false,
      selected: [],
      modalDelete: false
    }
  },
  computed: {
    ...mapGetters('exports', ['getExports'])
  },
  methods: {
    ...mapMutations('exports', [
      'setResults'
    ]),
    formatDateFromTimestamp (date) {
      if (date) {
        return moment.unix(date).format('DD/MM/YYYY HH:mm')
      }
    },
    async fetchList () {
      this.loading = true
      this.setResults(await getExports())
      this.loading = false
    },
    doSelect (type) {
      switch (type) {
        case '*':
          const tmpSelection = this.getExports.list.map(({ relativePathname }) => relativePathname)
          this.selected = _uniq(this.selected.concat(tmpSelection))
          this.toggleSelection()
          // this.$refs.tableExports.toggleAllSelection();
          break
        case null:
        default:
          this.selected = []
          // this.selection = "";
          this.$refs.tableExports.clearSelection()
      }
    },
    downloadAll () {
      downloadExports(this.getExports.list.map(a => a.relativePathname))
    },
    handleDownload (file) {
      downloadExports([file.relativePathname])
    },
    handleDownloadSelected () {
      downloadExports(this.selected)
    },
    async handleRemove () {
      let res = null
      if (this.selected.length === 1) {
        res = await removeExports([this.selected[0]])
        this.$message(res)
      } else {
        res = await removeExports(this.selected)
        this.$message(res)
      }

      this.selected = []
      this.modalDelete = false
      this.fetchList()
    },
    toggleSelection () {
      this.getExports.list.forEach(row => {
        if (this.selected.includes(row.relativePathname)) {
          this.$refs.tableExports.toggleRowSelection(row, true)
        }
      })
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        const self = this
        this.getExports.list.forEach(function (item) {
          const index = self.selected.indexOf(item.relativePathname)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
        // this.$refs.tableExports.clearSelection();
      } else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.relativePathname === row.relativePathname) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.relativePathname)

      if (add) {
        if (index === -1) {
          this.selected.push(row.relativePathname)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    },
    openDeleteModal (file = null) {
      if (file) {
        this.selected.push(file.relativePathname)
      }
      this.modalDelete = true
    }

  },
  async beforeMount () {
    await this.fetchList()
  }
}
</script>

<style lang="scss">
.el-loading-spinner {
  top: 10% !important;
}
</style>
